import { type Request, type Response } from "./workers/playback.worker";
import { WorkerManager } from "./WorkerManager";
import playbackWorkerFactory from "./workers/playbackWorkerFactory";

export class PlaybackEncoder {
    private static internalInstance = new PlaybackEncoder();

    public static get instance(): PlaybackEncoder {
        return PlaybackEncoder.internalInstance;
    }

    private readonly worker = new WorkerManager<Request, Response>(playbackWorkerFactory());

    public getPlaybackWaveform(input: Float32Array): Promise<number[]> {
        return this.worker.call({ data: Array.from(input) }).then((resp) => resp.waveform);
    }
}
